module.exports = __webpack_public_path__ + "static/media/car-side.5f9ad3b4.svg";